import { render, staticRenderFns } from "./PlanCreate.vue?vue&type=template&id=2b6d1c70&"
import script from "./PlanCreate.vue?vue&type=script&lang=js&"
export * from "./PlanCreate.vue?vue&type=script&lang=js&"
import style0 from "./PlanCreate.vue?vue&type=style&index=0&id=2b6d1c70&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports